import { z } from "zod"

export const GROUPINGS = ["country", "kind"] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const GROUPING_LABELS: Record<Grouping, string> = {
  country: "Country",
  kind: "Type",
}
